var map = {
	"./bmwicon-动作.svg": "4679",
	"./bmwicon-回应.svg": "d4b7",
	"./bmwicon-屏幕分享.svg": "7c70",
	"./bmwicon-屏幕分享关闭.svg": "c2a9",
	"./bmwicon-提问.svg": "a289",
	"./bmwicon-摄像头.svg": "9d82",
	"./bmwicon-摄像头关闭.svg": "0222",
	"./bmwicon-汽车动画.svg": "85ae",
	"./bmwicon-电影.svg": "a7b2",
	"./bmwicon-聊天.svg": "d8d9",
	"./bmwicon-视角锁定.svg": "869f",
	"./bmwicon-语音.svg": "3c50",
	"./bmwicon-语音关闭.svg": "a7c3",
	"./bmwicon-鼓掌.svg": "4699",
	"./bmwicon_back.svg": "cd6c",
	"./bmwicon_personal.svg": "a12d",
	"./bmwicon_举手.svg": "4451",
	"./bmwicon_令牌.svg": "1a1f",
	"./bmwicon_传送.svg": "b71d",
	"./bmwicon_净化ui.svg": "3f52",
	"./bmwicon_列表.svg": "0239",
	"./bmwicon_动作.svg": "1f8f",
	"./bmwicon_双车展示.svg": "72ec",
	"./bmwicon_地图.svg": "bb46",
	"./bmwicon_屏幕共享.svg": "0cb9",
	"./bmwicon_弹幕.svg": "262c",
	"./bmwicon_拍照.svg": "cea1",
	"./bmwicon_提问.svg": "4b53",
	"./bmwicon_摄像头.svg": "efea",
	"./bmwicon_播放视频.svg": "3249",
	"./bmwicon_数字人.svg": "93ef",
	"./bmwicon_更换车辆.svg": "2345",
	"./bmwicon_点点点.svg": "de49",
	"./bmwicon_点赞.svg": "1ad7",
	"./bmwicon_点赞非.svg": "3d89",
	"./bmwicon_禁用屏幕共享.svg": "6ae4",
	"./bmwicon_禁用摄像头.svg": "efda",
	"./bmwicon_禁用语音.svg": "4157",
	"./bmwicon_视角.svg": "2f7c",
	"./bmwicon_视角锁.svg": "5142",
	"./bmwicon_语音.svg": "2b05",
	"./bmwicon_贴花.svg": "552a",
	"./bmwicon_起立.svg": "63a7",
	"./bmwicon_车动画.svg": "12ca",
	"./bmwicon_车漆-26.svg": "d257",
	"./bmwicon_车漆-27.svg": "7926",
	"./bmwicon_退出.svg": "2ce3",
	"./bmwicon_邀请-20.svg": "05f8",
	"./bmwicon_邀请-30.svg": "3bc3",
	"./bmwicon_邀请1.svg": "0a52",
	"./bmwicon_销售带看.svg": "8fe8",
	"./bmwicon_鼓掌.svg": "78a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01d0";